import { Button, CircularProgress, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import LSPastVisitReportsComponent from 'src/consumer/components/LiveSessionPage/components/LSPastVisitReportsComponent/LSPastVisitReportsComponent'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'

export default function PastPatientReportsDialog({
  patientInfo,
  closeDialog,
  isInDialog = false,
  hideTitle = false,
  hideSendToDoctorButton = false,
  forceShowAllReports = false,
  patientHistoryGetApiSignature,
}) {
  let typesOfReportsToShow = ['prescription', 'therapy']
  let userType = 'therapist'
  if (!forceShowAllReports) {
    if (getAllRolesInBoolean().isDoctor) {
      userType = 'doctor'
      typesOfReportsToShow = ['prescription']
    }
  }

  if (isInDialog) {
    return (
      <>
        {!hideTitle && <DialogTitle>Past reports of {patientInfo?.name}</DialogTitle>}
        <DialogContent>
          <LSPastVisitReportsComponent
            skeletonNumber={2}
            hidePrintButton
            patientId={patientInfo?.id}
            typeOfReportsToShowArray={typesOfReportsToShow}
            hideSendToDoctorButton={hideSendToDoctorButton}
            customLoader={
              <div className="w-100 d-flex flex-column align-items-center justify-content-center">
                <h5>
                  Loading Past{' '}
                  {typesOfReportsToShow.length > 1 ? 'Reports' : typesOfReportsToShow[0]} of{' '}
                  {patientInfo?.name} ({patientInfo?.patientNumber})
                </h5>
                <CircularProgress />
              </div>
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => closeDialog()}>Close</Button>
        </DialogActions>
      </>
    )
  }

  return (
    <>
      <LSPastVisitReportsComponent
        skeletonNumber={2}
        hidePrintButton
        patientId={patientInfo?.id}
        typeOfReportsToShowArray={typesOfReportsToShow}
        patientHistoryGetApiSignature={patientHistoryGetApiSignature}
      />
    </>
  )
}
